export class DomHelper {
  public static scrollAndFocus(id: string): void {
    const element = document.getElementById(id) as HTMLElement;
    if (element !== null) {
      element.scrollIntoView();
      element.focus();
    }
  }

  public static focusOnFirstFocusableElement(element: HTMLElement | undefined | null): void {
    if (element === undefined || element === null) return;
    if (['BUTTON', 'A', 'INPUT', 'SELECT', 'TEXTAREA'].indexOf(element.tagName) > -1 && element.getAttribute('tabindex') !== '-1') {
      element.focus();
    } else {
      const focusableElements = element.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])') as NodeListOf<HTMLElement>;
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }
  }

  public static hideAllElementsWithTag(tag: string) {
    const elementArray = Array.prototype.slice.call(document.getElementsByTagName(tag));
    elementArray.forEach((element) => {
      const htmlElement = element as HTMLElement;
      htmlElement.hidden = true;
    });
  }

  public static showAllElementsWithTag(tag: string) {
    const elementArray = Array.prototype.slice.call(document.getElementsByTagName(tag));
    elementArray.forEach((element) => {
      const htmlElement = element as HTMLElement;
      htmlElement.hidden = false;
    });
  }
}
